const HEX_RE = /^[0-9a-fA-F]{6}$/;

export function contrastTextColor(hexColor: string): string {
  let hex = hexColor.replace('#', '');
  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('');
  }
  if (!HEX_RE.test(hex)) return '#ffffff';

  const channel = (offset: number): number => {
    const value = parseInt(hex.substring(offset, offset + 2), 16) / 255;
    return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
  };

  const luminance = 0.2126 * channel(0) + 0.7152 * channel(2) + 0.0722 * channel(4);

  return luminance > 0.179 ? '#000000' : '#ffffff';
}
